import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

interface WelcomePageProps {
  auth: {
    user: { name: string; email: string } | null;
    logout: () => void;
  };
}

export default function WelcomePage({ auth }: WelcomePageProps) {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="welcome-page">
      <aside className="welcome-sidebar">
        <div className="welcome-sidebar-brand">
          <h2>{t('auth.brand')}</h2>
        </div>
        <ul className="welcome-sidebar-nav">
          <li><a href="#" className="active" onClick={(e) => e.preventDefault()}>{t('nav.dashboard')}</a></li>
          <li><a href="#" onClick={(e) => e.preventDefault()}>{t('nav.myServices')}</a></li>
          <li><a href="#" onClick={(e) => e.preventDefault()}>{t('nav.orders')}</a></li>
          <li><a href="#" onClick={(e) => e.preventDefault()}>{t('nav.settings')}</a></li>
        </ul>
      </aside>

      <div className="welcome-main">
        <div className="welcome-topbar">
          <span style={{ marginInlineEnd: '1rem', color: '#6b7280', fontSize: '0.9375rem' }}>
            {auth.user?.name}
          </span>
          <button
            className="btn btn-logout"
            style={{ color: '#6b7280', borderColor: '#d1d5db' }}
            onClick={auth.logout}
          >
            {t('nav.logout')}
          </button>
        </div>

        <div className="welcome-content">
          <div className="welcome-card">
            <h1>{t('welcome.buildCatalogue')}</h1>
            <p>{t('welcome.addServicesDesc')}</p>
            <button
              className="btn-add-services"
              onClick={() => navigate('/dashboard')}
            >
              {t('welcome.addServices')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
